import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { toast } from 'react-toastify'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { LineScalePulseOut } from 'react-pure-loaders'
import EditIcon from '@material-ui/icons/Edit'
import { myProfileUser, myProfileUserUpdate } from '../../../../services/user'
import { MenuItem, Select } from '@material-ui/core'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding: 10
  },
  button: {
    margin: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    fontWeight: 700
  },
  input: {

    backgroundColor: '#fff',
  },
  input_image: {
    display: 'none',
  },
  textPattern: {
    color: '#000000'
  },
}));

export default function PixTab(props) {
  const classes = useStyles()
  const [submitting] = useState(false)
  const [edit, setEdit] = useState(false)

  useEffect(() => {
    const getMyProfile = async () => {
      await myProfileUser()
        .then(response => {
          setName(response.data.pixName || '')
          setType(response.data.pixType || '')
          setKey(response.data.pixKey || '')
        })
    }

    getMyProfile()
  }, [])

  const [pixName, setName] = useState('');
  const [pixType, setType] = useState('');
  const [pixKey, setKey] = useState('');



  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      pixName,
      pixType,
      pixKey,
    }

    await myProfileUserUpdate(data)
      .then(response => {
        setEdit(false)
        if (response?.data.success) {
          toast.success(response?.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Algo inesperado ocorreu. Por favor, tente novamente em alguns minutos.!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(error => {
        setEdit(false)
        toast.error('Algo inesperado ocorreu. Por favor, tente novamente em alguns minutos.!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .finally(() => {
        setEdit(false)
      })
  }


  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={12} className='cardFormCustomRadius paddingTabsCustom'>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item ></Grid>
          <Grid item style={{ marginTop: 16 }}>
            <Button
              type="button"
              startIcon={<EditIcon />}
              onClick={e => setEdit(!edit)}
              color={edit ? `primary` : `secondary`}
            >
              Editar
            </Button>
          </Grid>
        </Grid>

        <form onSubmit={handleSubmit} noValidate>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                className={classes.input}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="pix_name"
                label={<Typography className={classes.textPattern}>Nome completo</Typography>}
                name="pix_name"
                disabled={edit ? false : true}
                onChange={event => setName(event.target.value)}
                value={pixName}
              />
            </Grid>

            <Grid item xs={12} md={4} lg={4}>

              <Select
                native
                className={classes.input}
                name="pix_type"
                id="pix_type"
                variant="outlined"
                value={pixType}
                onChange={event => setType(event.target.value)}
                disabled={edit ? false : true}
                fullWidth
              >
                <option value={''}>Tipo</option>
                <option value={'CPF_CNPJ'}>CPF/CNPJ</option>
                <option value={'EMAIL'}>E-mail</option>
                <option value={'PHONE'}>Telefone</option>
                <option value={'RANDOM'}>Aleatório</option>
              </Select>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <TextField
                className={classes.input}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="bank_account"
                label={<Typography className={classes.textPattern}>Chave Pix</Typography>}
                name="bank_account"
                disabled={edit ? false : true}
                onChange={event => setKey(event.target.value)}
                value={pixKey}
              />
            </Grid>

            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Grid item ></Grid>
              <Grid item style={{ marginTop: 16, paddingRight: 10 }}>
                <Button
                  type="submit"
                  size='large'
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={edit ? false : true}
                >
                  {submitting ? (
                    <LineScalePulseOut
                      color={'#BA7100'}
                      loading={submitting}
                    />
                  ) : (
                    "Concluir"
                  )}
                </Button>
              </Grid>
            </Grid>

          </Grid>
        </form>
      </Grid>
    </Grid>
  )
}